<script>
import MenuLinkItem from '../menu-link-item/MenuLinkItem.vue'
import MenuCtaBlock from '../menu-cta-block/MenuCtaBlock.vue'

export default {
  name: 'MenuLinkSection',
  components: {
    MenuLinkItem,
    MenuCtaBlock
  },
  props: {
    links: {
      type: Array,
      required: true
    },
    heading: {
      type: String,
      default: ''
    },
    isFooter: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    sectionStyling() {
      if (!this.heading) return
      return this.isFooter
        ? 'menu-link-section__heading--footer text--white fw--xx-heavy'
        : 'heading-uppercase--medium'
    }
  },
  methods: {
    sectionType(type) {
      return type || 'menuLinkItem'
    }
  }
}
</script>

<template lang="pug">
.menu-link-section.sp__bottom--xs
  .menu-link-section__heading(:v-if='heading' :class='sectionStyling') {{ heading }}
  component(
    v-for='linkProps in links'
    :key='linkProps.text'
    :is='sectionType(linkProps.sectionType)'
    v-bind='linkProps'
    :hasLinkIcon='linkProps.linkIcon'
    :isHeading='linkProps.heading'
    :isFooter='isFooter'
    v-on='$listeners'
  )
</template>

<style lang="stylus" scoped>
@import '../../assets/styles/modules/*'

.menu-link-section
  &__heading
    padding-left: 20px

    &--footer
      padding: 10px 0
</style>
